import { Web3Wrapper } from '@0x/web3-wrapper'
import { ProviderType } from 'bzx-common/src/domain/ProviderTypeDictionary'

export class ProviderChangedEvent {
  public providerType: ProviderType
  public web3: Web3Wrapper | null

  constructor(providerType: ProviderType, web3: Web3Wrapper | null) {
    this.providerType = providerType
    this.web3 = web3
  }
}

export enum ProviderEvents {
  ProviderAvailable = 'ProviderAvailable',
  ProviderChanged = 'ProviderChanged',
  ProviderIsChanging = 'ProviderIsChanging',
}

export interface IProviderEvents {
  ProviderAvailable: (event: ProviderChangedEvent) => void
  ProviderChanged: (event: ProviderChangedEvent) => void
  ProviderIsChanging: () => void
}
